import { atom } from "jotai";

export const callConnectedInfo = atom(false);
